import { Injectable, inject } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";

import { MedappVersion } from "./../entities/medapp-version";
import { environment } from "environment";

@Injectable({
	providedIn: "root",
})
export class AppVersionService {
	private readonly http = inject(HttpClient);

	getLatestAppVersion(): Observable<MedappVersion> {
		return this.http.get<MedappVersion>(`${environment.AWS.API.URL}/currentversion`);
	}
}
